import { QuotationController } from './quotation.controller';
import { HttpService } from '@maia/httpClient';
import { ConfigService } from '@maia/config';
import {
  QuotationService,
  NoteService,
  TaskService,
  ActivityService,
} from '@maia/shared';

export class ServiceFactory {
  private readonly configService = new ConfigService();
  private readonly httpService = new HttpService(
    this.configService,
    'quotationUrl',
  );

  createQuotationController(): QuotationController {
    return new QuotationController(
      this.createQuotationService(),
      this.createNoteService(),
      this.createActivityService(),
      this.createTaskService(),
    );
  }

  private createQuotationService(): QuotationService {
    return new QuotationService(this.httpService, this.configService);
  }

  private createActivityService(): ActivityService {
    return new ActivityService(this.httpService, this.configService);
  }

  private createNoteService(): NoteService {
    return new NoteService(this.httpService, this.configService);
  }

  private createTaskService(): TaskService {
    return new TaskService(this.httpService, this.configService);
  }
}

const factory = new ServiceFactory();
export const service = factory.createQuotationController();
